import { render } from "./photoMenuComponent.vue?vue&type=template&id=29116e42&scoped=true"
import script from "./photoMenuComponent.vue?vue&type=script&lang=js"
export * from "./photoMenuComponent.vue?vue&type=script&lang=js"

import "./photoMenuComponent.vue?vue&type=style&index=0&id=29116e42&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\webencusco\\projects\\fronted-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29116e42"]])

export default __exports__